import { DecimalPipe } from '@angular/common';
import { Directive, HostListener, ElementRef, Renderer2 } from '@angular/core';
 
@Directive({
  selector: '[appPhoneNumber]',
  providers: [DecimalPipe],
})
export class PhoneNumberDirective {
  constructor(private el: ElementRef, private renderer: Renderer2) { }
 
  // Block non-numeric keys (desktop keyboards)
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const allowedKeys = [
      'Backspace', 'Tab', 'Delete', 'ArrowLeft', 'ArrowRight', 'Home', 'End'
    ];
 
    if (allowedKeys.indexOf(event.key) !== -1) {
      return;
    }
 
    // Allow common shortcuts (Ctrl/Cmd + V/C/X/A)
    if ((event.ctrlKey || event.metaKey) && ['v', 'c', 'x', 'a'].includes((event.key || '').toLowerCase())) {
      return;
    }
 
    // Block any non-digit keystrokes
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }
 
  // Sanitize the value on input, preserve caret and notify Angular by re-dispatching input
  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = this.el.nativeElement as HTMLInputElement;
    const raw = input.value || '';
    const sanitized = raw.replace(/[^0-9]/g, '');
 
    if (sanitized !== raw) {
      const selectionStart = input.selectionStart || 0;
      const previousLength = raw.length;
 
      // Update the native value
      this.renderer.setProperty(input, 'value', sanitized);
 
      // Try restore a reasonable caret position
      const newPos = Math.max(0, selectionStart - (previousLength - sanitized.length));
      try { input.setSelectionRange(newPos, newPos); } catch (e) { /* ignore */ }
 
      // Notify Angular forms that the value changed
      input.dispatchEvent(new Event('input'));
    }
  }
 
  // Handle paste: sanitize clipboard content, insert at caret, update value and notify Angular
  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
 
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const pasted = (clipboardData && clipboardData.getData) ? clipboardData.getData('text') : '';
    const sanitized = (pasted || '').replace(/[^0-9]/g, '');
 
    const input = this.el.nativeElement as HTMLInputElement;
    const start = input.selectionStart != null ? input.selectionStart : 0;
    const end = input.selectionEnd != null ? input.selectionEnd : 0;
    const value = input.value || '';
 
    const newValue = value.slice(0, start) + sanitized + value.slice(end);
    this.renderer.setProperty(input, 'value', newValue);
 
    const caretPos = start + sanitized.length;
    try { input.setSelectionRange(caretPos, caretPos); } catch (e) { /* ignore */ }
 
    input.dispatchEvent(new Event('input'));
  }
 
  // IME support: sanitize after composition finishes
  @HostListener('compositionend', ['$event'])
  onCompositionEnd(event: CompositionEvent) {
    this.onInput(event as unknown as Event);
  }
}